/* Slimix Ultra — par Biophael | JS du thème (vanilla) */
(function () {
  'use strict';

  function initMobileNav() {
    var t = document.querySelector('[data-nav-toggle]');
    var d = document.querySelector('[data-nav-drawer]');
    if (!t || !d) return;
    t.addEventListener('click', function () {
      var open = d.classList.toggle('is-open');
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    d.querySelectorAll('[data-nav-close]').forEach(function (el) {
      el.addEventListener('click', function () { d.classList.remove('is-open'); document.body.style.overflow = ''; });
    });
  }

  function initAccordions() {
    document.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('[data-accordion-item]');
        if (!item) return;
        var open = item.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        var panel = item.querySelector('[data-accordion-panel]');
        if (panel) panel.style.maxHeight = open ? panel.scrollHeight + 'px' : null;
      });
    });
  }

  function initGallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (g) {
      var main = g.querySelector('[data-gallery-main]');
      g.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          if (main && thumb.dataset.full) {
            main.style.opacity = 0;
            setTimeout(function () { main.src = thumb.dataset.full; main.style.opacity = 1; }, 120);
          }
          g.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });
  }

  function initPackSelector() {
    document.querySelectorAll('[data-pack-selector]').forEach(function (group) {
      var options = group.querySelectorAll('[data-pack-option]');
      var input = document.querySelector('[data-variant-input]');
      var priceEls = document.querySelectorAll('[data-current-price]');
      var compareEl = document.querySelector('[data-current-compare]');
      options.forEach(function (opt) {
        opt.addEventListener('click', function () {
          options.forEach(function (o) { o.classList.remove('is-selected'); });
          opt.classList.add('is-selected');
          if (input && opt.dataset.variantId) input.value = opt.dataset.variantId;
          priceEls.forEach(function (el) { if (opt.dataset.price) el.textContent = opt.dataset.price; });
          if (compareEl) { compareEl.textContent = opt.dataset.compare || ''; compareEl.style.display = opt.dataset.compare ? '' : 'none'; }
        });
      });
    });
  }

  function initQuantity() {
    document.querySelectorAll('[data-quantity]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('[data-qty-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var val = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.qtyStep, 10));
          input.value = val;
        });
      });
    });
  }

  function initAjaxCart() {
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var original = btn ? btn.innerHTML : '';
        if (btn) { btn.disabled = true; btn.innerHTML = '…'; }
        fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(serialize(form))
        }).then(function (r) { return r.json(); })
          .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
          .then(function (cart) { updateCount(cart.item_count); openCart(cart); })
          .catch(function () { window.location.href = '/cart'; })
          .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = original; } });
      });
    });
  }
  function serialize(form) {
    var id = form.querySelector('[name="id"]'), qty = form.querySelector('[name="quantity"]');
    var sp = form.querySelector('[name="selling_plan"]:checked');
    var p = { id: id ? id.value : null, quantity: qty ? parseInt(qty.value, 10) : 1 };
    if (sp && sp.value) p.selling_plan = sp.value;
    return p;
  }
  function updateCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; el.style.display = n > 0 ? '' : 'none'; });
  }
  function openCart(cart) {
    var d = document.querySelector('[data-cart-drawer]');
    if (!d) { window.location.href = '/cart'; return; }
    renderCart(d, cart); d.classList.add('is-open'); document.body.style.overflow = 'hidden';
  }
  function renderCart(d, cart) {
    var body = d.querySelector('[data-cart-body]'), total = d.querySelector('[data-cart-total]');
    if (body) {
      body.innerHTML = cart.items.length ? cart.items.map(function (i) {
        return '<div class="cart-line"><img src="' + (i.image ? i.image.replace(/(\.[^.]+)(\?|$)/, '_120x$1$2') : '') + '" alt="" width="60"><div class="cart-line__info"><strong>' + i.product_title + '</strong><span class="muted">x' + i.quantity + '</span></div><span>' + money(i.final_line_price) + '</span></div>';
      }).join('') : '<p class="muted" style="text-align:center;padding:2rem 0;">Votre panier est vide.</p>';
    }
    if (total) total.textContent = money(cart.total_price);
  }
  function money(c) { return (c / 100).toLocaleString('fr-FR', { style: 'currency', currency: (window.Shopify.currency && window.Shopify.currency.active) || 'EUR' }); }
  function initCartClose() {
    document.querySelectorAll('[data-cart-close]').forEach(function (el) {
      el.addEventListener('click', function () { var d = document.querySelector('[data-cart-drawer]'); if (d) d.classList.remove('is-open'); document.body.style.overflow = ''; });
    });
  }

  function initReveal() {
    if (!('IntersectionObserver' in window)) { document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } }); }, { threshold: .12 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  }

  function init() {
    initMobileNav(); initAccordions(); initGallery(); initPackSelector();
    initQuantity(); initAjaxCart(); initCartClose(); initReveal();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
